/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCartComboRequestSchema } from "./banquetCartComboRequestSchema.ts";
import { banquetCartItemRequestSchema } from "./banquetCartItemRequestSchema.ts";

export const banquetCartRequestSchema = z
	.object({
		items: z.array(banquetCartItemRequestSchema),
		combos: z.array(banquetCartComboRequestSchema),
		is_complete: z.boolean().describe("false — на кассе есть позиции официанта, которые гость не может вернуть в корзину: менять состав нельзя"),
	})
	.describe("Состав банкета в формате корзины заказа: тело для замены состава как есть.");
